// Announcement starts
(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    const daysElem = document.querySelector('.pe_announcement-countdown__days');
    const hoursElem = document.querySelector('.pe_announcement-countdown__hours');
    const minutesElem = document.querySelector('.pe_announcement-countdown__minutes');
    const secondsElem = document.querySelector('.pe_announcement-countdown__seconds');

    if (!daysElem || !hoursElem || !minutesElem || !secondsElem) return;

    const targetDateElem = document.querySelector('[data-countdown-target]');
    if (!targetDateElem) return;
    
    const targetDate = new Date(targetDateElem.getAttribute('data-countdown-target'));
    if (isNaN(targetDate.getTime())) return;

    function updateDisplay() {
      const now = new Date();
      const timeLeft = targetDate - now;
      
      if (timeLeft <= 0) {
        daysElem.textContent = '00';
        hoursElem.textContent = '00';
        minutesElem.textContent = '00';
        secondsElem.textContent = '00';
        if (window.countdownInterval) clearInterval(window.countdownInterval);
        return;
      }
      
      const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
      
      daysElem.textContent = String(days).padStart(2, '0');
      hoursElem.textContent = String(hours).padStart(2, '0');
      minutesElem.textContent = String(minutes).padStart(2, '0');
      secondsElem.textContent = String(seconds).padStart(2, '0');
    }

    updateDisplay();
    window.countdownInterval = setInterval(updateDisplay, 1000);
  });
})();
// Announcement ends



// Header starts
(function() {
  'use strict';

  let lastScrollPosition = 0;
  const header = document.querySelector('.pe_header-section');
  
  if (!header) return;

  const OFFSET_MULTIPLIER = 2;
  
  function getDisappearOffset() {
    return header.offsetHeight * OFFSET_MULTIPLIER;
  }
  
  function handleScroll() {
    const currentScrollPosition = window.scrollY || document.documentElement.scrollTop;
    const disappearOffset = getDisappearOffset();
    
    if (currentScrollPosition > lastScrollPosition && currentScrollPosition > disappearOffset) {
      header.classList.add('pe_header-section__disappear');
    } 
    else if (currentScrollPosition < lastScrollPosition) {
      header.classList.remove('pe_header-section__disappear');
    }
    
    lastScrollPosition = currentScrollPosition;
  }

  let ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      requestAnimationFrame(function() {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  });
})();


$(document).ready(function() {
  $('.pe_header-cart__js').on('click', function(e) {
    e.preventDefault();
    $('.pe_cart-drawer').addClass('active');
    $('body').addClass('pe_body-hidden');
  });

  $('.drawer__close, .cart-drawer__overlay').on('click', function(e) {
    e.preventDefault();
    $('body').removeClass('pe_body-hidden');
  });
});


(function() {
  'use strict';
  
  function updateCartCount() {
    const cartCountElement = document.querySelector('.pe_header-cart__count');
    if (!cartCountElement) return;
    
    fetch('/cart.js', { cache: 'no-store' })
      .then(response => response.json())
      .then(cart => {
        const itemCount = cart.item_count;
        cartCountElement.textContent = itemCount;
        
        if (itemCount > 0) {
          cartCountElement.classList.remove('empty');
        } else {
          cartCountElement.classList.add('empty');
        }
      })
      .catch(error => console.error('Error fetching cart:', error));
  }
  
  updateCartCount();
  
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    return originalFetch.apply(this, args).then(response => {
      const url = args[0];
      if (typeof url === 'string' && (
        url.includes('/cart/add') ||
        url.includes('/cart/update') ||
        url.includes('/cart/change')
      )) {
        setTimeout(updateCartCount, 300);
      }
      return response;
    });
  };
  
  document.addEventListener('click', function(e) {
    const atcButton = e.target.closest('[data-variant-id], .add-to-cart, .product-form__submit, .pe_cart-drawer__col-product-atc');
    if (atcButton) {
      setTimeout(updateCartCount, 500);
    }
  });
  
  document.addEventListener('cart:update', updateCartCount);
  
  document.addEventListener('visibilitychange', function() {
    if (!document.hidden) {
      updateCartCount();
    }
  });
  
  setInterval(updateCartCount, 3000);
})();
// Header ends



// Footer starts
$(document).ready(function() {
  $('.pe_footer-menu__heading').on('click', function(e) {
    e.preventDefault();
    
    var $this = $(this);
    var $currentMenu = $this.closest('.pe_footer-menu').find('.pe_footer-menu__menu');
    var $allMenus = $('.pe_footer-menu__menu');
    var $allHeadings = $('.pe_footer-menu__heading');
    
    if ($this.hasClass('active')) {
      $this.removeClass('active');
      $currentMenu.slideUp(200);
    } else {
      $allHeadings.removeClass('active');
      $allMenus.slideUp(200);
      
      $this.addClass('active');
      $currentMenu.slideDown(200);
    }
  });
  
});
// Footer ends



// Banner strats
var swiper = new Swiper(".pe_banner-slides", {
  loop: true,
  spaceBetween: 0,
  centeredSlides: false,
  adaptiveHeight: true,
  // autoplay: {
  //   delay: 5000,
  //   disableOnInteraction: false
  // },
  pagination: {
    el: ".pe_banner-pagination",
    clickable: true
  }
});
// Banner ends



// Strip starts
function initMarquee() {
  console.log('initMarquee function started');
  const containers = document.querySelectorAll('.marquee-container');
  console.log('Containers found:', containers.length);
  
  if (containers.length === 0) {
    console.log('No containers found!');
    return;
  }
  
  containers.forEach((container, index) => {
    console.log(`Processing container ${index + 1}`);
    
    const logoItems = container.querySelectorAll('.pe_strip-icon');
    console.log(`Number of logo items found in container ${index + 1}:`, logoItems.length);
    
    if (logoItems.length === 0) {
      console.log(`No logo items found in container ${index + 1}!`);
      return;
    }
    
    container.style.animation = 'none';
    container.style.display = 'flex';
    container.style.width = 'max-content';
    
    if (!container.dataset.originalContent) {
      container.dataset.originalContent = container.innerHTML;
      console.log(`Original content stored for container ${index + 1}`);
    }
    
    container.innerHTML = container.dataset.originalContent;
    const originalContent = container.innerHTML;
    container.innerHTML = originalContent + originalContent;
    console.log(`Content duplicated for container ${index + 1}`);
    
    void container.offsetHeight;
    
    const totalWidth = container.scrollWidth / 2;
    console.log(`Total width calculated for container ${index + 1}:`, totalWidth);
    
    const speedFactor = 50;
    const duration = Math.max(totalWidth / speedFactor, 10);
    console.log(`Duration for container ${index + 1}:`, duration);
    
    const keyframeName = `marquee-scroll-${index}`;
    
    const existingStyle = document.getElementById(`marquee-keyframes-${index}`);
    if (existingStyle) existingStyle.remove();
    
    const styleSheet = document.createElement("style");
    styleSheet.id = `marquee-keyframes-${index}`;
    styleSheet.textContent = `
      @keyframes ${keyframeName} {
        0% {
          transform: translateX(0);
        }
        100% {
          transform: translateX(-${totalWidth}px);
        }
      }
    `;
    document.head.appendChild(styleSheet);
    console.log(`Keyframes added for container ${index + 1}`);
    
    container.style.animation = `${keyframeName} ${duration}s linear infinite`;
    console.log(`Final animation applied to container ${index + 1}:`, container.style.animation);
    
    setTimeout(function() {
      const transform = window.getComputedStyle(container).transform;
      console.log(`Transform after 100ms for container ${index + 1}:`, transform);
    }, 100);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMarquee);
} else {
  initMarquee();
}

setTimeout(initMarquee, 500);
setTimeout(initMarquee, 1000);

document.addEventListener('shopify:section:load', function(event) {
  if (event.target.querySelector('.marquee-container')) {
    console.log('Section reloaded, reinitializing marquee');
    initMarquee();
  }
});
// Strip ends



// Tabs starts
$(document).ready(function() {
  $('.pe_tabs-button__js').on('click', function() {
    $('.pe_tabs-button__js').removeClass('active');
    $(this).addClass('active');
    var tabId = $(this).data('id');
    $('.pe_tabs-tab').removeClass('active');
    $('.pe_tabs-tab[data-tab="' + tabId + '"]').addClass('active');
  });
});
// Tabs ends



// Slider starts
document.addEventListener('DOMContentLoaded', function() {
  var peSliderSwiper = new Swiper(".pe_slider-slides", {
    loop: true,
    slidesPerView: 1.6,
    spaceBetween: 15,
    centeredSlides: false,
    navigation: {
      nextEl: ".pe_slider-arrow__next",
      prevEl: ".pe_slider-arrow__prev"
    },
    breakpoints: {
      491: {
        slidesPerView: 2.5,
        spaceBetween: 20
      },
      769: {
        slidesPerView: 3.4,
        spaceBetween: 20
      },
      1025: {
        slidesPerView: 4.3,
        spaceBetween: 25
      }
    }
  });

  var peSliderGrid = new Swiper(".pe_sliderg-slides", {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 10,
    centeredSlides: false,
    navigation: {
      nextEl: ".pe_sliderg-arrow__next",
      prevEl: ".pe_sliderg-arrow__prev"
    },
     pagination: {
      el: ".pe_sliderg-pagination",
      clickable: true
    }
  });

  function stopAllVideos() {
    document.querySelectorAll('.pe_slider-video video').forEach(function(video) {
      video.pause();
      var videoSlide = video.closest('.pe_slider-video');
      if (videoSlide) {
        var playBtn = videoSlide.querySelector('.pe_slider-video__play');
        var pauseBtn = videoSlide.querySelector('.pe_slider-video__pause');
        if (playBtn && pauseBtn) {
          playBtn.style.display = 'flex';
          pauseBtn.style.display = 'none';
        }
      }
    });
  }

  function setupVideoControls(videoSlide) {
    var video = videoSlide.querySelector('video');
    var playBtn = videoSlide.querySelector('.pe_slider-video__play');
    var pauseBtn = videoSlide.querySelector('.pe_slider-video__pause');
    
    if (!video || !playBtn || !pauseBtn) return;
    
    pauseBtn.style.display = 'none';
    playBtn.style.display = 'flex';
    
    playBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      stopAllVideos();
      
      video.muted = false;
      
      video.play().catch(function(error) {
        console.log('Play failed:', error);
        video.muted = true;
        video.play();
      });
      
      playBtn.style.display = 'none';
      pauseBtn.style.display = 'flex';
    });
    
    pauseBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      video.pause();
      playBtn.style.display = 'flex';
      pauseBtn.style.display = 'none';
    });
    
    video.addEventListener('ended', function() {
      playBtn.style.display = 'flex';
      pauseBtn.style.display = 'none';
    });
  }

  function setupAllVideos() {
    document.querySelectorAll('.pe_slider-video').forEach(function(videoSlide) {
      setupVideoControls(videoSlide);
    });
  }

  setupAllVideos();

  peSliderSwiper.on('slideChange', function() {
    stopAllVideos();
  });

  peSliderGrid.on('slideChange', function() {
    stopAllVideos();
  });

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (node.classList && node.classList.contains('pe_slider-video'))) {
            setupVideoControls(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('.pe_slider-video').forEach(function(videoSlide) {
              setupVideoControls(videoSlide);
            });
          }
        });
      }
    });
  });
  
  observer.observe(document.querySelector('.swiper-wrapper'), { childList: true, subtree: true });
});
// Slider ends



// Faqs starts
$(document).ready(function() {
  $('.pe_faqs-faq__header').on('click', function() {
    var $this = $(this);
    var $faq = $this.closest('.pe_faqs-faq');
    var $body = $faq.find('.pe_faqs-faq__body');
    
    if ($faq.hasClass('active')) {
      $faq.removeClass('active');
      $body.slideUp(200);
    } else {
      $('.pe_faqs-faq').each(function() {
        $(this).removeClass('active');
        $(this).find('.pe_faqs-faq__body').slideUp(200);
      });
      
      $faq.addClass('active');
      $body.slideDown(200);
    }
  });
});
// Faqs ends



// Boards starts
$(document).ready(function() {
  function animateNumber(element, targetNumber) {
    var $element = $(element);
    var currentNumber = 0;
    var duration = 2000;
    var stepTime = 20;
    var steps = duration / stepTime;
    var increment = targetNumber / steps;
    
    var timer = setInterval(function() {
      currentNumber += increment;
      if (currentNumber >= targetNumber) {
        $element.text(Math.round(targetNumber));
        clearInterval(timer);
      } else {
        $element.text(Math.floor(currentNumber));
      }
    }, stepTime);
  }
  
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var $countSpan = $(entry.target);
        if (!$countSpan.hasClass('animated')) {
          $countSpan.addClass('animated');
          var targetNumber = parseFloat($countSpan.data('target'));
          animateNumber(entry.target, targetNumber);
        }
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3 });
  
  $('.pe_boards-board__count').each(function() {
    observer.observe(this);
  });
});
// Boards ends



// Reveal starts
document.addEventListener('DOMContentLoaded', function() {
  const section = document.querySelector('.pe_reveal-section');
  if (!section) return;
  
  const lines = section.querySelectorAll('.pe_reveal-line');
  if (!lines.length) return;
  
  const headings = [];
  let animationComplete = false;
  const totalLines = lines.length;
  
  const CONFIG = {
    speed: 2.5,
    startOffset: 0.2,
    easing: true
  };
  
  lines.forEach((line) => {
    const heading = line.querySelector('h3');
    if (heading) {
      headings.push(heading);
      heading.style.transform = 'translate(0%, 100%)';
    }
  });
  
  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }
  
  function handleScroll() {
    if (animationComplete) return;
    
    const rect = section.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    
    if (rect.top > windowHeight || rect.bottom < 0) {
      return;
    }
    
    const totalScrollDistance = rect.height + windowHeight;
    let scrolled = Math.max(0, Math.min(1, (windowHeight - rect.top - (CONFIG.startOffset * windowHeight)) / totalScrollDistance));
    
    scrolled = Math.min(scrolled * CONFIG.speed, 1);
    
    if (CONFIG.easing) {
      scrolled = easeOutCubic(scrolled);
    }
    
    const progressPerLine = 1 / totalLines;
    const currentLineIndex = Math.min(Math.floor(scrolled / progressPerLine), totalLines - 1);
    const lineProgress = Math.min((scrolled - (currentLineIndex * progressPerLine)) / progressPerLine, 1);
    
    headings.forEach((heading, index) => {
      if (index < currentLineIndex) {
        heading.style.transform = 'translate(0px, 0px)';
      } else if (index === currentLineIndex) {
        if (lineProgress >= 1) {
          heading.style.transform = 'translate(0px, 0px)';
        } else {
          const translateY = 100 - (lineProgress * 63.5484);
          heading.style.transform = `translate(0%, ${translateY}%) translate3d(0px, 0px, 0px)`;
        }
      } else {
        heading.style.transform = 'translate(0%, 100%)';
      }
    });
    
    if (scrolled >= 1) {
      animationComplete = true;
      headings.forEach(heading => {
        heading.style.transform = 'translate(0px, 0px)';
      });
    }
  }
  
  let ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  });
  
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(handleScroll, 100);
  });
  
  setTimeout(handleScroll, 100);
});
// Reveal ends



// Featured collection starts
(function() {
  window.featuredCollectionATC = {
    isAdding: false,
    
    addToCart: async function(variantId, buttonElement) {
      if (this.isAdding) return;
      
      this.isAdding = true;
      const originalBtnText = buttonElement.textContent;
      
      buttonElement.textContent = 'Adding...';
      buttonElement.disabled = true;
      
      try {
        const cartDrawerElement = document.querySelector('cart-drawer');
        
        const formDataObject = new FormData();
        formDataObject.append('id', variantId);
        formDataObject.append('quantity', 1);
        
        if (cartDrawerElement) {
          const sectionsArray = cartDrawerElement.getSectionsToRender().map(section => section.id);
          formDataObject.append('sections', sectionsArray.join(','));
          formDataObject.append('sections_url', window.location.pathname);
          cartDrawerElement.setActiveElement(document.activeElement);
        }
        
        const fetchResponse = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: {
            'Accept': 'application/json'
          },
          body: formDataObject
        });
        
        const responseData = await fetchResponse.json();
        
        if (responseData.status) {
          console.error('ATC Error:', responseData);
          buttonElement.textContent = 'Error!';
          setTimeout(() => {
            buttonElement.textContent = originalBtnText;
            buttonElement.disabled = false;
            window.featuredCollectionATC.isAdding = false;
          }, 2000);
          return;
        }
        
        if (cartDrawerElement && typeof cartDrawerElement.renderContents === 'function') {
          cartDrawerElement.renderContents(responseData);
        }
        
        if (window.publish && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'featured-collection',
            productVariantId: variantId,
            cartData: responseData
          });
        }
        
        const cartDataResponse = await fetch('/cart.js');
        const cartData = await cartDataResponse.json();
        
        const countElements = document.querySelectorAll('.pe_header-cart__count, .cart-count-bubble');
        countElements.forEach(element => {
          if (element) element.textContent = cartData.item_count;
        });
        
        const cartDrawerWrapper = document.querySelector('.pe_cart-drawer');
        if (cartDrawerWrapper) {
          if (cartData.item_count > 0) {
            cartDrawerWrapper.classList.remove('is-empty');
          } else {
            cartDrawerWrapper.classList.add('is-empty');
          }
        }
        
        buttonElement.textContent = 'Added!';
        setTimeout(() => {
          buttonElement.textContent = originalBtnText;
          buttonElement.disabled = false;
          window.featuredCollectionATC.isAdding = false;
        }, 2000);
        
      } catch (error) {
        console.error('ATC Error:', error);
        buttonElement.textContent = originalBtnText;
        buttonElement.disabled = false;
        window.featuredCollectionATC.isAdding = false;
      }
    }
  };
  
  document.addEventListener('click', function(event) {
    const targetButton = event.target.closest('.pe_featured_collection .pe_pro-atc');
    
    if (targetButton && !window.featuredCollectionATC.isAdding) {
      event.preventDefault();
      event.stopPropagation();
      
      const variantIdValue = targetButton.getAttribute('data-variant-id');
      if (variantIdValue) {
        window.featuredCollectionATC.addToCart(variantIdValue, targetButton);
      }
    }
  });
  
  if (!window.routes) {
    window.routes = {};
  }
  if (!window.routes.cart_add_url) {
    window.routes.cart_add_url = '/cart/add';
  }
})();
// Featured collection ends



// Main product starts
// document.addEventListener('DOMContentLoaded', function() {
//   let sectionElement = document.querySelector('.pe_product');
//   let isThumbnailClicking = false;
  
//   if (!sectionElement) {
//     return;
//   }
  
//   function getSelectedValues() {
//     const selectedValues = [];
    
//     const variantOptions = sectionElement.querySelectorAll('.pe_product-option__input:checked');
    
//     variantOptions.forEach(option => {
//       if (option.value) {
//         let normalizedValue = option.value.toLowerCase();
//         normalizedValue = normalizedValue.replace(/[®™]/g, '');
//         normalizedValue = normalizedValue.trim();
//         selectedValues.push(normalizedValue);
//       }
//     });
    
//     return selectedValues;
//   }
  
//   function normalizeAlt(alt) {
//     if (!alt) return '';
//     return alt.toLowerCase().trim();
//   }
  
//   function matchesSelectedValue(alt, selectedValues) {
//     const normalizedAlt = normalizeAlt(alt);
    
//     for (const selected of selectedValues) {
//       if (normalizedAlt.includes(selected) || selected.includes(normalizedAlt)) {
//         return true;
//       }
//     }
//     return false;
//   }
  
//   function filterMediaByVariant() {
//     if (isThumbnailClicking) {
//       return;
//     }
    
//     const selectedValues = getSelectedValues();
    
//     if (selectedValues.length === 0) {
//       showAllMedia();
//       return;
//     }
    
//     const slides = sectionElement.querySelectorAll('.pe_product-slider__slide');
//     const thumbnails = sectionElement.querySelectorAll('.pe_product-thumbnail__slide');
    
//     let visibleCount = 0;
    
//     slides.forEach(slide => {
//       const alt = slide.getAttribute('data-alt') || '';
//       const shouldShow = matchesSelectedValue(alt, selectedValues);
      
//       if (shouldShow) {
//         slide.style.display = '';
//         visibleCount++;
//       } else {
//         slide.style.display = 'none';
//       }
//     });
    
//     thumbnails.forEach(thumbnail => {
//       const alt = thumbnail.getAttribute('data-alt') || '';
//       const shouldShow = matchesSelectedValue(alt, selectedValues);
//       thumbnail.style.display = shouldShow ? '' : 'none';
//     });
    
//     if (visibleCount === 0) {
//       showAllMedia();
//     }
    
//     if (!isThumbnailClicking) {
//       activateFirstVisibleSlide();
//     }
//   }
  
//   function showAllMedia() {
//     const slides = sectionElement.querySelectorAll('.pe_product-slider__slide');
//     const thumbnails = sectionElement.querySelectorAll('.pe_product-thumbnail__slide');
    
//     slides.forEach(slide => {
//       slide.style.display = '';
//     });
    
//     thumbnails.forEach(thumbnail => {
//       thumbnail.style.display = '';
//     });
//   }
  
//   function activateFirstVisibleSlide() {
//     const visibleSlides = Array.from(sectionElement.querySelectorAll('.pe_product-slider__slide')).filter(slide => {
//       return slide.style.display !== 'none';
//     });
    
//     if (visibleSlides.length > 0) {
//       const firstVisibleSlide = visibleSlides[0];
//       const mediaId = firstVisibleSlide.getAttribute('data-media-id');
      
//       if (mediaId) {
//         const thumbnail = sectionElement.querySelector(`.pe_product-thumbnail__slide[data-target="${mediaId}"] button`);
//         if (thumbnail && !thumbnail.disabled) {
//           thumbnail.click();
//         }
//       }
//     }
//   }
  
//   function handleVariantChange() {
//     filterMediaByVariant();
//   }
  
//   function setupThumbnailTracking() {
//     sectionElement.addEventListener('click', function(e) {
//       const thumbnail = e.target.closest('.pe_product-thumbnail__slide button');
//       if (thumbnail) {
//         isThumbnailClicking = true;
//         setTimeout(() => {
//           isThumbnailClicking = false;
//         }, 500);
//       }
//     });
//   }
  
//   function setupEventListeners() {
//     sectionElement.addEventListener('change', function(e) {
//       const target = e.target;
//       if (target.classList && target.classList.contains('pe_product-option__input')) {
//         setTimeout(handleVariantChange, 100);
//       }
//     });
//   }
  
//   function setupMutationObserver() {
//     let observerTimeout;
    
//     const observer = new MutationObserver(function(mutations) {
//       if (isThumbnailClicking) return;
      
//       if (observerTimeout) clearTimeout(observerTimeout);
//       observerTimeout = setTimeout(() => {
//         filterMediaByVariant();
//       }, 200);
//     });
    
//     observer.observe(sectionElement, {
//       childList: true,
//       subtree: true
//     });
//   }
  
//   function init() {
//     setTimeout(filterMediaByVariant, 500);
//     setupEventListeners();
//     setupMutationObserver();
//     setupThumbnailTracking();
//   }
  
//   init();
  
//   window.productGallery = {
//     filter: filterMediaByVariant,
//     reset: showAllMedia,
//     getSelected: getSelectedValues
//   };
// });
// Main product ends



// Featured product starts
$(document).ready(function() {
  $('.pe_product-faq__header').on('click', function() {
    var $thisp = $(this);
    var $faqp = $thisp.closest('.pe_product-faq');
    var $bodyp = $faqp.find('.pe_product-faq__body');
    
    if ($faqp.hasClass('active')) {
      $faqp.removeClass('active');
      $bodyp.slideUp(200);
    } else {
      $('.pe_product-faq').each(function() {
        $(this).removeClass('active');
        $(this).find('.pe_product-faq__body').slideUp(200);
      });
      
      $faqp.addClass('active');
      $bodyp.slideDown(200);
    }
  });
});
// Featured product ends



// Cart drawer starts
document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', async function(e) {
    const atcButton = e.target.closest('.pe_cart-drawer__col-product-atc');
    
    if (atcButton) {
      e.preventDefault();
      e.stopPropagation();
      
      const variantId = atcButton.getAttribute('data-variant-id');
      if (!variantId) return;
      
      const originalText = atcButton.textContent;
      atcButton.textContent = 'Adding...';
      atcButton.disabled = true;
      
      try {
        const cartDrawer = document.querySelector('cart-drawer');
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);
        
        if (cartDrawer) {
          const sectionsToRender = cartDrawer.getSectionsToRender().map(section => section.id);
          formData.append('sections', sectionsToRender.join(','));
          formData.append('sections_url', window.location.pathname);
          cartDrawer.setActiveElement(document.activeElement);
        }
        
        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: {
            'Accept': 'application/json'
          },
          body: formData
        });
        
        const responseData = await response.json();
        
        if (responseData.status) {
          console.error('Error adding to cart:', responseData);
          atcButton.textContent = 'Error';
          setTimeout(() => {
            atcButton.textContent = originalText;
            atcButton.disabled = false;
          }, 2000);
          return;
        }
        
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(responseData);
        }
        
        if (window.publish && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'custom-atc',
            productVariantId: variantId,
            cartData: responseData
          });
        }
        
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        document.querySelectorAll('.pe_header-cart__count, .cart-count-bubble').forEach(el => {
          if (el) el.textContent = cart.item_count;
        });
        
        const peCartDrawer = document.querySelector('.pe_cart-drawer');
        if (peCartDrawer && cart.item_count > 0) {
          peCartDrawer.classList.remove('is-empty');
        } else if (peCartDrawer && cart.item_count === 0) {
          peCartDrawer.classList.add('is-empty');
        }
        
        atcButton.textContent = 'Added!';
        setTimeout(() => {
          atcButton.textContent = originalText;
          atcButton.disabled = false;
        }, 2000);
        
      } catch (error) {
        console.error('Error:', error);
        atcButton.textContent = originalText;
        atcButton.disabled = false;
      }
    }
  });
});


(function() {
  document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('click', async function(e) {
      const atcButton = e.target.closest('.pe_cart-upsell__product-atc');
      
      if (atcButton) {
        e.preventDefault();
        e.stopPropagation();
        
        const variantId = atcButton.getAttribute('data-variant-id');
        if (!variantId) return;
        
        const originalText = atcButton.textContent;
        atcButton.textContent = 'Adding...';
        atcButton.disabled = true;
        
        try {
          const cartDrawer = document.querySelector('cart-drawer');
          const formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', 1);
          
          if (cartDrawer) {
            const sectionsToRender = cartDrawer.getSectionsToRender().map(section => section.id);
            formData.append('sections', sectionsToRender.join(','));
            formData.append('sections_url', window.location.pathname);
            cartDrawer.setActiveElement(document.activeElement);
          }
          
          const response = await fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: {
              'Accept': 'application/json'
            },
            body: formData
          });
          
          const responseData = await response.json();
          
          if (responseData.status) {
            console.error('Error adding to cart:', responseData);
            atcButton.textContent = 'Error';
            setTimeout(() => {
              atcButton.textContent = originalText;
              atcButton.disabled = false;
            }, 2000);
            return;
          }
          
          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(responseData);
          }
          
          if (window.publish && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
              source: 'upsell-atc',
              productVariantId: variantId,
              cartData: responseData
            });
          }
          
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();
          document.querySelectorAll('.pe_header-cart__count, .cart-count-bubble').forEach(el => {
            if (el) el.textContent = cart.item_count;
          });
          
          const peCartDrawer = document.querySelector('.pe_cart-drawer');
          if (peCartDrawer && cart.item_count > 0) {
            peCartDrawer.classList.remove('is-empty');
          } else if (peCartDrawer && cart.item_count === 0) {
            peCartDrawer.classList.add('is-empty');
          }
          
          atcButton.textContent = 'Added!';
          setTimeout(() => {
            atcButton.textContent = originalText;
            atcButton.disabled = false;
          }, 2000);
          
        } catch (error) {
          console.error('Error:', error);
          atcButton.textContent = originalText;
          atcButton.disabled = false;
        }
      }
    });
  });
})();
// Cart drawer ends
